module.exports = __webpack_public_path__ + "180119aa883a02dd20231b3933cc2f8b.jpg";